import { __ } from '@wordpress/i18n';
import {InspectorControls} from '@wordpress/block-editor';
import {VayuBlocksAdvancePanel} from '@vayu-blocks/advance-panel';
import UnfoldSettingPanel from './settings';
import UnfoldStylePanel from './style';
import {VayuBlocksHeaderTab, usePanelSettings} from '@vayu-blocks';

const panelKeys = [
	'settings-option',
	'settings-transition',
	'settings-settings',
	
	'Style-color',
	'Style-button',
];

const initialPanels = {
	slide: 'settings-settings',
	overlay: '',
	advanced: '',
};

const panelOptions = [
	{ label: __('General', 'vayu-blocks'), value: 'slide', icon: 'colorwand',},
	{ label: __('Style', 'vayu-blocks'), value: 'overlay', icon: 'diamond',},
	{ label: __('Advanced', 'vayu-blocks'), value: 'advanced', icon: 'colorpalette',},
];

const PanelSettings = ({attributes,setAttributes,isSelected,clientId }) => {

	const { tab, setTab, openPanels, onTogglePanel } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'slide' });

	const tabComponents = {
		slide: <UnfoldSettingPanel attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		overlay: <UnfoldStylePanel attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		advanced: <VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} clientId={clientId} video={true} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
	};
	
    return (
		<>
			{isSelected && (
				<InspectorControls>
					<div className='th-block-ins th-button-panel'>

						<VayuBlocksHeaderTab 
							value={ tab }
							options={panelOptions}
							onChange={ setTab }
						/>

						{tabComponents[tab]}

					</div>
				</InspectorControls>  
			)}

    	</>
	);
}

export default PanelSettings;